import styled from "styled-components";

import Button from "core/Button";

import { convertPxToRem } from "frontend/components/helpers";

export const CtaContainer = styled.div`
    margin-top: ${convertPxToRem({ px: 32 })};

    ${Button} {
        margin-right: ${convertPxToRem({ px: 24 })};
    }
`;
